export const normalizeAccount = (raw, defaults, fallbackAccountName) => {
    const tryUpper = (v) => (typeof v === "string" ? v.toUpperCase() : v);
    const wallet = raw?.data?.data ?? raw?.data ?? raw ?? null;
    if (!wallet) return null;

    const walletCurrency = tryUpper(wallet.currency);
    const want = tryUpper(defaults);
    if (!walletCurrency || walletCurrency !== want) return null;

    const providers = Array.isArray(wallet.providers) ? wallet.providers : [];
    const provider =
        providers.find((p) => tryUpper(p?.currency) === walletCurrency) ?? providers[0] ?? {};

    return {
        currency: walletCurrency,
        balance: Number(wallet.balance ?? 0),
        accountNumber: provider.accountNumber || "",
        bankName: provider.bankName || provider.bank || "",
        branchName: provider.branchName || "",
        accountName: provider.accountName || fallbackAccountName || "",
        iban: provider.iban || "",
        swift: provider.swift || "",
        _raw: { wallet, provider },
        bankAddress: provider.bankAddress,
        paymentRails: provider.paymentRails,
        bankCode: provider.bankCode,
        routingNumber: provider.routingNumber,
    };
};
